/* «¿Tenés un código? +» del carrito (snippets/gs-cart-codigo.liquid), Ganga Shop V2.
   - Plegado: se abre con un toque; nunca abierto de entrada.
   - Aplicar = /cart/update.js con discount = los códigos que YA tiene el carrito + el nuevo (no los reemplaza).
     Si Shopify lo marca como no aplicable, se vuelve a dejar la lista como estaba y se avisa.
   - Con éxito, el carrito se redibuja por el mismo camino del tema (FoxTheme.pubsub cartUpdate con las secciones
     del cajón y de /cart): el total, los chips de descuento y la barra de envío gratis salen ya descontados.
   - «Usar BIENVENIDA10»: si la persona copió el código en el pop-up (localStorage «gs-codigo-copiado», lo guarda
     assets/gs-popup-news.js) y todavía no está aplicado. Un toque lo aplica.
   - El pie se redibuja entero en cada cambio del carrito: un solo listener delegado y un MutationObserver
     sobre <cart-drawer> y <main-cart> que vuelve a mirar si hay que ofrecer el código. Nada mide en scroll. */
(function () {
  'use strict';
  if (window.__gsCartCodigo) return;
  window.__gsCartCodigo = true;

  var CLAVE = 'gs-codigo-copiado';
  var TXT = {
    vacio: 'Escribí el código.',
    ya: 'Ese código ya está aplicado.',
    no: 'No pudimos aplicar {c}. Revisá que esté bien escrito y que sirva para estos productos.',
    error: 'No pudimos aplicar el código. Probá de nuevo.',
    ok: 'Listo: {c} aplicado.',
    aplicando: 'Aplicando…'
  };
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ocupado = false;

  function copiado() {
    try { return String(window.localStorage.getItem(CLAVE) || '').trim().toUpperCase(); } catch (e) { return ''; }
  }
  function lista(txt) {
    return String(txt || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  }
  function tiene(arr, c) {
    var u = c.toUpperCase();
    return arr.some(function (x) { return String(x).toUpperCase() === u; });
  }
  function texto(t, c) { return t.replace('{c}', c); }

  /* ---------- ofrecer el código copiado ---------- */
  function refrescar() {
    var cod = copiado();
    var valido = /^[A-Z0-9][A-Z0-9_-]{2,39}$/.test(cod);
    document.querySelectorAll('[data-gs-cod]').forEach(function (box) {
      var usar = box.querySelector('[data-gs-cod-usar]');
      if (!usar) return;
      var mostrar = valido && !tiene(lista(box.getAttribute('data-aplicados')), cod);
      /* solo se toca el DOM si cambia algo: el MutationObserver de abajo vuelve a llamar a esta función */
      if (mostrar) {
        if (usar.getAttribute('data-codigo') !== cod) usar.setAttribute('data-codigo', cod);
        var n = usar.querySelector('[data-gs-cod-nombre]');
        if (n && n.textContent !== cod) n.textContent = cod;
      }
      if (usar.hidden !== !mostrar) usar.hidden = !mostrar;
    });
  }
  var pendiente = false;
  function refrescarLuego() {
    if (pendiente) return;
    pendiente = true;
    setTimeout(function () { pendiente = false; refrescar(); }, 0);
  }

  /* ---------- carrito ---------- */
  function seccionesDelTema() {
    var s = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: s } }));
    } catch (e) {}
    return s.filter(function (x, i) { return x && s.indexOf(x) === i; });
  }
  function codigosActuales() {
    return fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cods = [];
        if (Array.isArray(cart.discount_codes)) {
          cart.discount_codes.forEach(function (d) { if (d && d.code && !tiene(cods, d.code)) cods.push(d.code); });
          return { cods: cods, cart: cart };
        }
        /* respaldo: los descuentos de tipo código del carrito y de las líneas */
        (cart.cart_level_discount_applications || []).forEach(function (a) {
          if (a.type === 'discount_code' && a.title && !tiene(cods, a.title)) cods.push(a.title);
        });
        (cart.items || []).forEach(function (it) {
          (it.line_level_discount_allocations || []).forEach(function (al) {
            var a = al.discount_application || {};
            if (a.type === 'discount_code' && a.title && !tiene(cods, a.title)) cods.push(a.title);
          });
        });
        return { cods: cods, cart: cart };
      });
  }
  function actualizar(cods, secciones) {
    var body = { discount: cods.join(',') };
    if (secciones && secciones.length) {
      body.sections = secciones.join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(raiz + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function redibujar(cart, secciones) {
    var T = window.FoxTheme;
    var conSecciones = cart && cart.sections && secciones.length && secciones.every(function (id) { return cart.sections[id]; });
    if (conSecciones && T && T.pubsub && T.pubsub.publish) {
      T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      return true;
    }
    if (document.querySelector('cart-drawer')) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      return true;
    }
    window.location.reload();
    return false;
  }

  function mensaje(box, t, ok) {
    var m = box && box.querySelector('[data-gs-cod-msj]');
    if (!m) return;
    m.textContent = t || '';
    m.classList.toggle('is-ok', !!ok);
    var input = box.querySelector('.gs-cod__input');
    if (input) {
      if (t && !ok) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }
  function cargando(btn, si) {
    if (!btn) return;
    if (si) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      if (!btn.hasAttribute('data-texto')) btn.setAttribute('data-texto', btn.innerHTML);
      btn.textContent = TXT.aplicando;
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (btn.hasAttribute('data-texto')) btn.innerHTML = btn.getAttribute('data-texto');
    }
  }

  function aplicar(codigo, box, btn) {
    var c = String(codigo || '').trim();
    if (!c) { mensaje(box, TXT.vacio); var i = box.querySelector('.gs-cod__input'); if (i) i.focus(); return; }
    if (ocupado) return;
    ocupado = true;
    mensaje(box, '');
    cargando(btn, true);
    var antes = [];
    var secciones = seccionesDelTema();
    codigosActuales()
      .then(function (res) {
        antes = res.cods;
        if (tiene(antes, c)) {
          var d = (res.cart.discount_codes || []).filter(function (x) { return String(x.code).toUpperCase() === c.toUpperCase(); })[0];
          throw { gs: d && d.applicable === false ? texto(TXT.no, c.toUpperCase()) : TXT.ya };
        }
        return actualizar(antes.concat(c), secciones);
      })
      .then(function (cart) {
        var d = (cart.discount_codes || []).filter(function (x) { return String(x.code).toUpperCase() === c.toUpperCase(); })[0];
        if (!d || d.applicable === false) {
          /* no aplica: la lista de códigos vuelve a ser la de antes (sin redibujar: no cambió nada) */
          return actualizar(antes, []).catch(function () {}).then(function () { throw { gs: texto(TXT.no, c.toUpperCase()) }; });
        }
        ocupado = false;
        if (redibujar(cart, secciones)) {
          setTimeout(function () {
            refrescar();
            var nuevo = document.querySelector('[data-gs-cod]');
            mensaje(nuevo, texto(TXT.ok, c.toUpperCase()), true);
          }, 60);
        }
      })
      .catch(function (err) {
        ocupado = false;
        cargando(btn, false);
        mensaje(box, err && err.gs ? err.gs : TXT.error);
      });
  }

  /* ---------- eventos (delegados: el pie se redibuja entero) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var abrir = t.closest('[data-gs-cod-abrir]');
    if (abrir) {
      var box = abrir.closest('[data-gs-cod]');
      var panel = box && box.querySelector('.gs-cod__panel');
      if (!panel) return;
      var abierto = abrir.getAttribute('aria-expanded') === 'true';
      abrir.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      panel.hidden = abierto;
      box.classList.toggle('is-abierto', !abierto);
      if (abierto) { mensaje(box, ''); return; }
      var input = panel.querySelector('.gs-cod__input');
      if (input) { try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); } }
      return;
    }
    var usar = t.closest('[data-gs-cod-usar]');
    if (usar) {
      e.preventDefault();
      aplicar(usar.getAttribute('data-codigo'), usar.closest('[data-gs-cod]'), usar);
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-gs-cod-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('.gs-cod__input');
    aplicar(input ? input.value : '', form.closest('[data-gs-cod]'), form.querySelector('.gs-cod__aplicar'));
  });
  /* el pop-up avisa cuando se copia el código (misma página) */
  document.addEventListener('gs:codigo-copiado', refrescarLuego);
  window.addEventListener('storage', function (e) { if (e.key === CLAVE) refrescarLuego(); });

  function vigilar() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(refrescarLuego);
    document.querySelectorAll('cart-drawer, main-cart').forEach(function (el) {
      mo.observe(el, { childList: true, subtree: true });
    });
  }
  function iniciar() { refrescar(); vigilar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
